import './styles.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import Card from '@mui/material/Card';
import React, { useEffect, useState } from 'react';
import ReactMapboxGl, { Marker } from 'react-mapbox-gl';
import { setRTLTextPlugin, getRTLTextPluginStatus } from 'mapbox-gl';
import { Box, Button, Stack, styled } from '@mui/material';
import { toast } from 'react-toastify';

const Map = ReactMapboxGl({
  accessToken: 'pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4M29iazA2Z2gycXA4N2pmbDZmangifQ.-g_vE53SD2WrJ6tFX7QHmA',
  interactive: false,
  preserveDrawingBuffer: true,
});

const GeoFieldTemplate = ({ init, shipping }) => {
  const [showShipper, setShowShipper] = useState(false);
  const [center, setCenter] = useState(init);
  useEffect(() => {
    const status = getRTLTextPluginStatus();
    if (status === 'unavailable') {
      setRTLTextPlugin(
        'https://www.parsimap.com/scripts/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.0/mapbox-gl-rtl-text.js'
      );
    }
  }, []);

  const changeCenter = () => {
    if (!shipping[0]) {
      return toast.warn("موقعیت پیک در دسترس نیست!")
    }
    setCenter(!showShipper ? shipping : init);
    return setShowShipper(!showShipper);
  };

  return (
    <Card
      style={{
        boxShadow: 'none',
        border: '1px dashed #989898',
        marginBottom: 8,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Map
        zoom={[15]}
        style="/assets/map/light.json"
        containerStyle={{ height: '200px', width: '100%', borderRadius: 10 }}
        center={center}
        movingMethod="easeTo"
      >
        <Marker coordinates={init} anchor="center">
          <StyledBox width={16} height={16} borderRadius={2} bgcolor="info.main" color="info" sx={{ opacity: 0.9 }} />
        </Marker>
        {shipping[0] && (
          <Marker coordinates={shipping} anchor="center">
            <StyledBox
              width={16}
              height={16}
              borderRadius={2}
              bgcolor="error.main"
              color="error"
              sx={{ opacity: 0.9 }}
            />
          </Marker>
        )}
        <Stack width="100%" rowGap={1} sx={{ position: 'absolute', bottom: 0, p: 1, zIndex: 1000 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" columnGap={1}>
            <Button
              sx={{ width: 140 }}
              size="small"
              variant="contained"
              onClick={changeCenter}
              color={!showShipper ? 'error' : 'primary'}
            >
              {showShipper ? 'موقعیت مشتری' : 'موقعیت پیک'}
            </Button>
          </Stack>
        </Stack>
      </Map>
    </Card>
  );
};

const StyledBox = styled(Box)(({ theme, color = 'info' }) => ({
  '&::after': {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    animation: 'ripple 1.2s infinite ease-in-out',
    border: '1px solid',
    borderColor: theme.palette[color].main,
    content: '""',
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}));

export default GeoFieldTemplate;
